import { property, curry } from 'lodash-es';
import { compose } from 'redux';
import { jsonApi } from '../http-request';
import { map, propEq, propFromSelector } from '../utils';
import { selectors as move } from '../move';

const collection = jsonApi.selectors.collection('users');
const findResource = jsonApi.findResource(collection);

const findResourceAndHydrate = curry((fn, state) =>
  compose(
    jsonApi.utils.hydrate(state),
    findResource(fn)
  )(state)
);

const createFacade = selector => {
  const propFromResource = propFromSelector(selector);

  return {
    id: propFromResource('id'),
    identity: selector,
    firstName: propFromResource('first_name'),
    lastName: propFromResource('last_name'),
    email: propFromResource('email'),
    homePhone: propFromResource('home_phone'),
    cellPhone: propFromResource('cell_phone'),
    signedUpAt: propFromResource('signed_up_at'),
    metadata: propFromResource('metadata'),
    moveId: propFromResource('current_move_id'),
    moves: compose(
      map(move.byId),
      map(property('id')),
      propFromResource('moves')
    ),
    siteEntityId: propFromResource('site_entity_id'),
    uuid: propFromResource('uuid'),
    test: propFromResource('test'),
    claimedInviteId: propFromResource('claimed_invite_id'),
  };
};

export const byId = id =>
  createFacade(findResourceAndHydrate(propEq('id', String(id))));
